import { useEffect, useState } from "react";
import { appApis } from "../../constants";
import StockCardLayout from "./../Inventory/components/StockCardLayout";
import { useApiRequest } from "../../hooks/useApiRequest";
import LoadingElement from "../../Common/LoadingElement"
import PieChartSwitcher from "./components/PieChart";
import Histogram from "./components/Histogram";
import DashboardCards from "./components/DashboardCards";

const convertObjintoChartData = (obj) => {
    return Object.keys(obj).map(item => {
        return { name: item, value: obj[item] };
    });
}

const Dashboard = () => {
    const {request , loading} = useApiRequest();
    const [state, setState] = useState({
        inventoryCount: [],
        inventoryType: "",
        reports: [],
        chartData: [],
        vehicles: [],
        requests: [],
        installersStock: []
    });
    const { inventoryCount, inventoryType, reports, chartData, vehicles, requests, installersStock } = state;
    const { request: loadType, loading: isLoadType } = useApiRequest();
    const { request: loadReportType } = useApiRequest();

    const onSelectHandler = (value) => {
        const counts = value?.state_counts || {};
        const chartData = convertObjintoChartData(counts);
        setState(prev => ({ ...prev, inventoryType: value, chartData }));
    }

    const getIntCount = () => {
        loadType({
            url: appApis.getInventoryCount,
            showToast: false,
            onSuccess: (response) => {
                if (response?.data?.inventories) {
                    const inventories = response?.data?.inventories ?? [];
                    const selectedInv = inventories?.[0] ?? {};
                    const counts = selectedInv?.state_counts || {};
                    const chartData = convertObjintoChartData(counts)
                    setState(prev => ({ ...prev, inventoryCount: inventories, inventoryType: selectedInv, chartData }));
                }
            }
        })
    }

    const getDashboardSummary = () => {
        loadReportType({
            url: appApis.dashboardReport,
            showToast: false,
            onSuccess: (response) => {
                if(response?.data){
                    const dashboardData = response.data;
                    const report = dashboardData.reports ?? {};
                    setState(prev => ({
                        ...prev, 
                        reports: Object.entries(report || {}).map(([key, value], index) => ({
                            id: index,
                            name: String(key)?.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()) ?? "",
                            count: value
                        })),
                        vehicles: dashboardData.vehicles || [],
                        requests: dashboardData.logs || [],
                        installersStock: dashboardData.installersStock || []
                    }))
                }
            }
        })
    }

    useEffect(() => {
        getIntCount();
        getDashboardSummary();
    }, [])

    return isLoadType ? <LoadingElement /> : <div className="inventory-container">
        {/* <DashboardCards /> */}
        <StockCardLayout inventoryCount={reports} inventoryType={null} />
        <StockCardLayout {...{inventoryCount, inventoryType}} filterAction={onSelectHandler} />
        {chartData?.length ? <PieChartSwitcher chartData={chartData} chartList={null} type={inventoryType?.name ?? ""} /> : null}
        <Histogram installersStock={installersStock} chartList={null} type="Installer" />
        <DashboardCards vehicles={vehicles} requests={requests} loading={isLoadType} />
    </div>
}

export default Dashboard;